<coop-good-price-form
  [editMode]="false"
  [templateMode]="false"
  [formData]="formData"
></coop-good-price-form>
